module.exports = __webpack_public_path__ + "static/media/responsibility.6300f6a6.svg";